module.exports = __webpack_public_path__ + "static/media/easypaisalogo.35fad070.svg";